var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"fluid":"","fill-height":""}},[_c('v-expand-x-transition',[_c('landing-toolbar')],1),_c('v-container',{staticStyle:{"min-width":"100% !important"}},[_c('Reports')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }